module.exports = __webpack_public_path__ + "img/home-video.46cf1694.png";